import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, date, formatError } from "../../lib/api";
import { LearnerDetail } from "./LearnerDetail";

export const LearnersAdmin = ({ me }) => {
  const [users, setUsers] = useState(null);
  const [q, setQ] = useState("");
  const [viewing, setViewing] = useState(null);
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data)).catch((e) => toast.error(formatError(e)));
  useEffect(() => { load(); }, []);
  const setRole = async (u, role) => {
    if (!window.confirm(`Change ${u.email} to ${role}?`)) return;
    try { await api.patch(`/admin/users/${u.id}/role`, { role }); toast.success("Role updated"); load(); } catch (e) { toast.error(formatError(e)); }
  };
  if (!users) return <div className="loading">Loading users…</div>;
  const shown = users.filter((u) => `${u.name} ${u.email}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <div className="section-title"><h2>Learners & roles</h2><input className="search" data-testid="learners-search-input" placeholder="Search name or email" value={q} onChange={(e) => setQ(e.target.value)} /></div>
      <div className="table-wrap"><table className="admin-table"><thead><tr><th>Name</th><th>Email</th><th>Sign-in</th><th>Joined</th><th>Role</th><th /></tr></thead>
        <tbody>{shown.map((u) => (
          <tr key={u.id} data-testid={`user-row-${u.email}`}><td><b>{u.name}</b></td><td>{u.email}</td><td>{u.google_linked ? "Google" : "Email"}</td><td>{date(u.created_at)}</td>
            <td><select data-testid={`user-role-select-${u.email}`} value={u.role} disabled={u.id === me.id} onChange={(e) => setRole(u, e.target.value)}><option value="learner">Learner</option><option value="admin">Admin</option></select></td>
            <td><button className="button outline compact" data-testid={`view-user-${u.email}`} onClick={() => setViewing(u.id)}>View</button></td></tr>))}
        </tbody></table></div>
      {viewing && <LearnerDetail userId={viewing} onClose={() => setViewing(null)} />}
    </div>
  );
};
